import {useQuery} from "@tanstack/react-query";
import {useTranslation} from "next-i18next";
import React from "react";
import {getObjectExtras} from "../../data/ReactQueries";
import {objectsAttributes} from "../../models/objects";
import GridTable from "./GridTable";

interface WeitereLeistungenProps {
	object: objectsAttributes;
}

function WeitereLeistungen({object}: WeitereLeistungenProps) {
	const optionaleExtras: string[][] = [];
	const {t} = useTranslation();
	const {data: objectExtras} = useQuery(["objectExtras"], getObjectExtras);

	const filteredData = objectExtras
		?.filter((item) => {
			if (Number(item.value)) {
				return item;
			}
		})
		.sort((a, b) => {
			return a.sorting - b.sorting;
		});

	let items: string[][] = [];
	filteredData?.map((item) => {
		switch (item.description) {
			case "bedding":
				items.push([
					t("components.weitereLeistungen.beddingText"),
					t("common.price", {price: item.value})
				]);
				break;
			case "towels":
				items.push([
					t("components.weitereLeistungen.towelsText"),
					t("common.price", {price: item.value})
				]);
				break;
			case "extra bed":
				items.push([
					t("components.weitereLeistungen.extraBedText"),
					t("common.price", {price: item.value})
				]);
				break;
			case "baby_chair":
				items.push([
					t("components.weitereLeistungen.babyChairText"),
					t("common.price", {price: item.value})
				]);
				break;
			case "babybed":
				items.push([
					t("components.weitereLeistungen.babyBedText"),
					t("common.price", {price: item.value})
				]);
				break;
			case "baby_buggy":
				// items.push([
				//   t("components.weitereLeistungen.babyBuggyText"),
				//   t("common.price",{price:item.value})
				// ]);
				break;
			default:
				items.push([
					t(item.description),
					t("common.price", {price: item.value})
				]);
				break;
		}
	});

	return (
		<div className="space-y-5 lg:grid grid-cols-7 place-items-center lg:space-y-0 lg:gap-y-10">
			<div className="space-y-7 lg:col-span-3 lg:place-self-start">
				<h3 className="lg:mb-16">
					{t("components.weitereLeistungen.optionalServices")}
				</h3>
				<p className="italic">
					{t("components.weitereLeistungen.longTermRentText")}
				</p>
				<GridTable
					head={[
						t("components.weitereLeistungen.service"),
						t("components.weitereLeistungen.price")
					]}
					rows={items ?? []}
					scroll={false}
				/>
			</div>
			<div className="lg:col-span-1 lg:h-full">
				<div
					className="
        bg-leo-divider-gray-2 w-full h-[2px] my-12 
        lg:h-full lg:w-[3px] lg:my-0
        "
				/>
			</div>
			<div className="space-y-7 lg:col-span-3 lg:place-self-start">
				<h3 className="lg:mb-16">
					{t("components.weitereLeistungen.extraCleaning")}
				</h3>
				<GridTable
					head={[
						t("components.weitereLeistungen.service"),
						t("components.weitereLeistungen.price")
					]}
					rows={[
						[
							t("components.weitereLeistungen.cleaningServiceText"),
							t("components.weitereLeistungen.uponConsultation")
						]
					]}
					scroll={false}
				/>
			</div>
			<div className="hidden lg:col-span-7 lg:place-self-center py-14 border-y-[3px] border-leo-divider-gray-2 w-full md:flex justify-center">
				<p className="italic text-center font-semibold text-leo-orange max-w-[500px]">
					{t("components.weitereLeistungen.noCarCharger")}
				</p>
			</div>
		</div>
	);
}

export default WeitereLeistungen;
